/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatLastReadEntry
 */
export interface ChatLastReadEntry {
    /**
     * 
     * @type {string}
     * @memberof ChatLastReadEntry
     */
    room_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatLastReadEntry
     */
    time?: number;
}

/**
 * Check if a given object implements the ChatLastReadEntry interface.
 */
export function instanceOfChatLastReadEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChatLastReadEntryFromJSON(json: any): ChatLastReadEntry {
    return ChatLastReadEntryFromJSONTyped(json, false);
}

export function ChatLastReadEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatLastReadEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'room_id': !exists(json, 'room_id') ? undefined : json['room_id'],
        'time': !exists(json, 'time') ? undefined : json['time'],
    };
}

export function ChatLastReadEntryToJSON(value?: ChatLastReadEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'room_id': value.room_id,
        'time': value.time,
    };
}

